// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { HubV1GetAccountGetAccountResponseModel } from './hubV1GetAccountGetAccountResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class HubV1HubV1GetAccountDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': HubV1GetAccountGetAccountResponseModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof HubV1HubV1GetAccountDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "HubV1GetAccountGetAccountResponseModel"
        },
    ];

    static getAttributeTypeMap() {
        return HubV1HubV1GetAccountDefaultResponse.attributeTypeMap;
    }
}
